import styles from "./MainWrapper.module.scss";

const MainWrapper = ({ decrease, size, children }) => {
  return <div className={styles.MainWrapper} size={size} decrease={decrease}>{children}</div>;
};

export default MainWrapper;
